import { useEffect } from "react";
import "./App.css";

export default function Home() {
  useEffect(()=>{ document.title = "GearChecker"; },[]);

  return (
    <main className="app-bg">
      <div className="main-container">
        <section className="gc-container gc-hero">
          <h1>GearChecker</h1>
          <p className="lead">
            Check your character gear, discover Best-In-Slot (BIS) items, and quickly spot
            what to improve. This site pulls item data from Caverns of Time and character
            info from Warmane to give you a fast and practical overview.
          </p>
        </section>

        <section className="gc-container gc-features">
          <h2>Main features</h2>
          <ul>
            <li>
              <strong>Search for characters</strong> — Find them by name and realm and inspect their stats and gear.
            </li>
            <li>
              <strong>BIS lists</strong> — View curated BIS lists by class and
              specialization to optimize your character.
            </li>
            <li>
              <strong>Missing gems and enchants</strong> — Instantly detect empty sockets
              and missing enchantments so you can fix them.
            </li>
            <li>
              <strong>Actual specialization</strong> — Identify the active character spec.
            </li>
            <li>
              <strong>Online/offline status</strong> — Quickly check if a character is online.
            </li>
            <li>
              <strong>Guild and rank</strong> — See current guild membership and rank at a glance.
            </li>
            <li>
              <strong>Model previews</strong> — Preview how items look on different races and genders.
            </li>
            <li>
              <strong>Raid achievements</strong> — Quickly check if the character has completed endgame raids.
            </li>
            <li>
              <strong>Raid statistics</strong> — View how many times a certain boss encounter was completed.
            </li>
            <li>
              <strong>Recent achievements</strong> — See recent achievements and their completion date.
            </li>
            <li>
              <strong>Skills</strong> — View your character's current skills and their level.
            </li>
            <li>
              <strong>Gear score calculation</strong> — See your current GS and how
              upgrades affect it.
            </li>
          </ul>
        </section>

        <section className="gc-container gc-notes">
          <h2>Data sources and availability</h2>
          <ul>
            <li>
              <strong>Caverns of Time</strong> — Item stats and icons.
            </li>
            <li>
              <strong>Warmane API</strong> — Character information (items, enchants, gems, online, guild).
            </li>
            <li>
              <strong>Warmane armory</strong> — Character information (guild rank, specialization, talents, achievements, statistics).
            </li>
          </ul>
          <p>
            <strong>If Warmane is down or unavailable, this site won't work properly.</strong>
          </p>
          <p>
            This is a beta site — you may encounter a few bugs. Please report issues and ideas in our Discord.
          </p>
        </section>

        <section className="gc-container gc-contact">
          <h2>Support and feedback</h2>
          <p>
            Have questions or feature ideas? Join our Discord from the footer and ask us
            anything. Feedback is very welcome.
          </p>
        </section>
      </div>
    </main>
  );
}
